module.exports = __webpack_public_path__ + "img/connection.e0064a4c.svg";